import styled from 'styled-components/native';
import { themes } from '../../design/colors';

export const Bar = styled.View`
  flex-direction: row;
  background-color: ${themes.colors.white};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  padding: 10px 8px 12px 8px;
  shadow-color: ${themes.colors.black};
  shadow-opacity: 0.08;
  shadow-radius: 12px;
  shadow-offset: 0px -4px;
  elevation: 12;
`;

export const TabButton = styled.TouchableOpacity`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled.View<{ focused?: boolean }>`
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 32px;
  border-radius: 16px;
  background-color: ${(props) => (props.focused ? themes.colors.blue0 : 'transparent')};
`;

export const Label = styled.Text<{ focused?: boolean }>`
  margin-top: 4px;
  font-size: 11px;
  color: ${(props) => (props.focused ? themes.colors.primary : themes.colors.gray1)};
  font-weight: ${(props) => (props.focused ? '700' : '400')};
`;
